export default __webpack_public_path__ + "static/media/Steadfastness of Jovus.7c2bc402.jpg";